import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "step step--gray" }
const _hoisted_2 = { class: "step__wrapper step__wrapper--bg_main page-wrapper page-wrapper--bg-part" }
const _hoisted_3 = { class: "g-container g-container--fit_main-width relative relative--align_center" }
const _hoisted_4 = { class: "subscription-wrapper" }
const _hoisted_5 = { class: "g-row g-row--space_none" }
const _hoisted_6 = { class: "g-cell g-cols g-cols--auto" }
const _hoisted_7 = { class: "step-block relative" }
const _hoisted_8 = { class: "step-block__logo" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "logo__image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo__img",
    width: "82",
    height: "82",
    src: "/static/app/mob-logo.svg",
    alt: "hq vpn logo",
    title: ""
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "logo__text" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo__img",
    src: "/static/app/logo-font.svg",
    alt: "hq vpn logo text",
    title: ""
  })
], -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "step-block__steps" }
const _hoisted_14 = {
  key: 0,
  class: "ds-caption ds-caption--size_xl ds-caption--size_5xl-xl ds-caption--bold ds-caption--color_white ds-caption--appearance_center"
}
const _hoisted_15 = {
  key: 0,
  class: "step-block__subscriptions"
}
const _hoisted_16 = {
  key: 1,
  class: "step-block__payment"
}
const _hoisted_17 = {
  key: 2,
  class: "step-block__email-form"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_step_detector = _resolveComponent("step-detector")!
  const _component_step_one = _resolveComponent("step-one")!
  const _component_payment_selector = _resolveComponent("payment-selector")!
  const _component_step_two = _resolveComponent("step-two")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("a", {
                    class: "logo link",
                    href: $setup.indexPage,
                    target: "_self"
                  }, _hoisted_12, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_step_detector, {
                    step: $setup.isFinalStep ? $setup.step - 1 : $setup.step,
                    shortened: $setup.isFinalStep
                  }, null, 8, ["step", "shortened"])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["step-block__title", 3 == $setup.step? "disabled-till-xl" : ""])
                }, [
                  ($setup.step)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString($setup.titles[$setup.step -1].title), 1))
                    : _renderSlot(_ctx.$slots, "default", { key: 1 })
                ], 2),
                (1 == $setup.step)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_step_one, {
                        onNext: _cache[0] || (_cache[0] = ($event: any) => ($setup.getNextStep($event))),
                        "is-auth": $setup.isAuth,
                        list: $setup.list,
                        is_reselect: $setup.reSelect
                      }, null, 8, ["is-auth", "list", "is_reselect"])
                    ]))
                  : ($setup.extendSub ? 2 == $setup.step : 3 == $setup.step)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_payment_selector, {
                          onBack: _cache[1] || (_cache[1] = ($event: any) => ($setup.reSelectSub())),
                          sub: $setup.subscription,
                          order: $setup.idOrder,
                          sub_key: $setup.subKey
                        }, null, 8, ["sub", "order", "sub_key"])
                      ]))
                    : ($setup.extendSub ? false : 2 == $setup.step)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_step_two, {
                            onNext: _cache[2] || (_cache[2] = ($event: any) => ($setup.getNextStep($event))),
                            sub: $setup.subscription
                          }, null, 8, ["sub"])
                        ]))
                      : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}